module.exports = __webpack_public_path__ + "img/as-mobile-services.bd2b8540.jpg";